// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --agentHighlightAngle{syntax:"<angle>";inherits:false;initial-value:0deg}@keyframes YDDsM{from{--agentHighlightAngle: 0deg}to{--agentHighlightAngle: 360deg}}@keyframes LQy7k{0%{opacity:0}18%{opacity:1}78%{opacity:1}100%{opacity:0}}.Evib6{display:flex;align-items:center;gap:8px;white-space:nowrap}.kT6IX{display:block}.kT6IX.Zp6Im{opacity:.5}.PkJL_{display:flex;align-items:center;color:#089475}.PkJL_ svg{padding-bottom:2px}.vhMkk{display:flex;align-items:center;color:#e86161}.vhMkk svg{padding-bottom:2px}._ptSu{display:flex;justify-content:center;width:20px}.Q0PPZ{margin-block-end:24px;gap:16px;justify-content:space-between}.Tw68n{flex-shrink:0}.SKVEK{display:flex;align-items:center;gap:8px}.awspE{margin-top:16px}.edFEM{display:block;opacity:1}.edFEM.hkxwh{opacity:.5}.O5dd5{position:relative}.O5dd5::after{content:"";position:absolute;inset:0;z-index:4;border-radius:inherit;padding:2px;background:conic-gradient(from var(--agentHighlightAngle), #2cf1ff, #7856f9, #ff5f8f, #2cf1ff);mask:linear-gradient(#ffffff 0 0) content-box,linear-gradient(#ffffff 0 0);mask-composite:exclude;-webkit-mask:linear-gradient(#ffffff 0 0) content-box,linear-gradient(#ffffff 0 0);-webkit-mask-composite:xor;pointer-events:none;animation:YDDsM 1.4s linear forwards,LQy7k 1.4s ease forwards}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"inlineEditMode": `Evib6`,
	"aiSearchOverlay": `kT6IX`,
	"dimmed": `Zp6Im`,
	"bulkRequestsResultSuccess": `PkJL_`,
	"bulkRequestsResultFailure": `vhMkk`,
	"bulkActionIcon": `_ptSu`,
	"filterPickerGroup": `Q0PPZ`,
	"headerActions": `Tw68n`,
	"scheduledTooltip": `SKVEK`,
	"importModalNote": `awspE`,
	"aiSearchContainer": `edFEM`,
	"submitting": `hkxwh`,
	"highlight": `O5dd5`,
	"agentHighlightSpin": `YDDsM`,
	"agentHighlightFade": `LQy7k`
};
export default ___CSS_LOADER_EXPORT___;
